module.exports = __webpack_public_path__ + "img/undraw_black_lives_matter_rndk.c95b0955.svg";